
import { State } from '../state';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { selectBpmnModelerState } from './bpmn-modeler-state.selector';
import { BpmnNodeCreatedResult } from '@ispm-client/modules/bpmn-modeler/models/bpmn-node-created-result';
import { NodeCreationResult } from '@ispm-client/modules/bpmn-modeler/models/node-creation-result';
import { TreatmentPlanSelectorResult } from '@ispm-client/modules/bpmn-modeler/models/treatment-plan-selector-result';

const getNodesCreationInfo = (state: State): Map<string, BpmnNodeCreatedResult<NodeCreationResult | TreatmentPlanSelectorResult>> => state.nodesCreationInfo;

export const selectNodesCreationInfo: MemoizedSelector<object, Map<string, BpmnNodeCreatedResult<NodeCreationResult | TreatmentPlanSelectorResult>>> =
    createSelector(selectBpmnModelerState, getNodesCreationInfo);

export const selectNodeCreationInfoById = (ids: Array<string>) => createSelector(
    selectNodesCreationInfo,
    nodesCreationInfo => ids.map(id => nodesCreationInfo[id])
);

